import React from 'react';
import PropTypes from 'prop-types';
// shared
import { LocaleString } from '@biw/intl';

const GoalAchievementMessage = ( { isMinimumQualifierEnabled } ) => {
    if ( isMinimumQualifierEnabled ) {
        return <LocaleString code="common.bonus.goalMQAchievedText"/>;
    } else {
        return <LocaleString code="common.bonus.goalAchievementText"/> ;
    }
};

GoalAchievementMessage.propTypes = {
	isMinimumQualifierEnabled: PropTypes.bool.isRequired
};

export default GoalAchievementMessage;
